<template>
  <div id="app" class="min-h-screen leading-normal text-base text-gray-900">
    <router-view class="router-view" id="content" />
    <Footer />
  </div>
</template>
<script>
import Footer from './components/Footer'

export default {
  components: { Footer }
}
</script>
<style lang="sass">
.router-view
  @apply mb-8 px-2
.hero
  @apply max-h-screen overflow-y-hidden relative text-white

.hero-bottom
  @apply w-full absolute bottom-0 text-center justify-center flex flex-col
.hero-image
  @apply w-full
</style>
